import { ClientSettingTypeEnum } from '@/dto';
import {
    IResetSettingsModel,
} from '../settingsChangeServiceContract';

export class ResetSettingsModel implements IResetSettingsModel {
    public settingType: ClientSettingTypeEnum;
    public roleName?: string;
    public userId?: string;

    constructor(settingType: ClientSettingTypeEnum) {
        this.settingType = settingType;
    }

}
